import { useEffect, useState } from "react";
import styles from "./LoginForm.module.css";
import rowStyle from "./Row.module.css"
import "./Row.module.css"
import { useDispatch } from "react-redux";
import { login, updateUser } from "../../Utils/Redux/UserSlice";
import { Link, useNavigate } from "react-router-dom";
import { GET_CONFIG_DETAILS, MAINTENANCE_STATUS, SEND_ONBOARD_EMAIL_VERIFIER, USER_LOGIN } from "../../Utils/constant"
import { Icon } from 'react-icons-kit'
import {basic_eye} from 'react-icons-kit/linea/basic_eye';
import {basic_eye_closed} from 'react-icons-kit/linea/basic_eye_closed';
import cogoToast from "cogo-toast-react-17-fix";

import Modal from "../../Utils/Modal";
import ChangePass from "../DashBoard/ChangePass";
import API from '../../ApiConfig'
import Loader from "../Loader";
import addIssuer from "../../pages/DashBoard/addIssuer.module.css"
import { BUTTONS } from "../../Utils/Strings";
import { EMAIL_CHECK, NAME_CHECK_WITH_NUMBER } from "../../Utils/helper";
import { setConfig } from "../../Utils/Redux/configSlice";
const LoginForm = ({disableLogin}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const [email, setemail] = useState("")
  const [password, setPassword] = useState("")
  const [rememberMe, setRememberMe] = useState(false)
  const [loading, setLoading] = useState(false)
  const[passVisible,setPassVisible]=useState(false);
  const [signUp, setSignUpPopup]=useState(false)
  const [Popup,setPopup]=useState(false);
  const updatePopup = (bool)=>{
    setPopup(bool)
  }
  // const MAX_ATTEMPTS = 3;
  // useEffect(()=>{


  //   if (!localStorage.getItem("loginAttempts")) {
  //     localStorage.setItem("loginAttempts", MAX_ATTEMPTS);
  //   }

  // },[])
  // console.log(disableLogin);
  const AddSingleUsers = () => {
    const [userForm, setUserForm] = useState({
      issuer: "verifier", // fixed to verifier
      company_name: "",
      email: "",
      company_alias: "",
      category: "", // verifier type (optional)
    });
  
    const [loading, setLoading] = useState(false);
    const [userError, setUserError] = useState({});
    const [verifierType, setVerifierType] = useState("Select Verifier type");
    
    const [showsuccessContent, setshowSuccessContent]=useState(false)
    const handleAddUser = async (e) => {
      e.preventDefault();
      let isValid = true;
      let tempError = {};
  
      // 🔍 Validate company name
      if (!userForm.company_name || !NAME_CHECK_WITH_NUMBER(userForm.company_name)) {
        isValid = false;
        tempError.company_name = true;
      }
  
      // 🔍 Validate email
      if (!userForm.email || !EMAIL_CHECK(userForm.email)) {
        isValid = false;
        tempError.email = true;
      }
  
      // 🔍 Validate alias (optional)
      if (userForm.company_alias && !NAME_CHECK_WITH_NUMBER(userForm.company_alias)) {
        isValid = false;
        tempError.company_alias = true;
      }
      userForm.category="3"
      // 🔍 Validate verifier type (if required)
      // if (verifierType === "Select Verifier type") {
      //   isValid = false;
      //   tempError.category = true;
      // } else {
      //   userForm.category = verifierType;
      // }
  
      const emailAPI = SEND_ONBOARD_EMAIL_VERIFIER;
      if (!emailAPI) {
        isValid = false;
        tempError.api = true;
      }
  
      setUserError(tempError);
      if (!isValid) return;
  
      setLoading(true);
      try {
        const res = await API.post(emailAPI, userForm);
        setLoading(false);
        if (res.status === 200) {

          
          setshowSuccessContent(true)
          // cogoToast.success(`Link Sent to ${userForm.email}`);
        } else {
          setSignUpPopup(false)
          cogoToast.error("Verifier could not be added!");
        }
      } catch (err) {
        setSignUpPopup(false)
        setLoading(false);
        cogoToast.error(err.response?.data?.message || "Something went wrong!");
      }
    };
  
    const handleChange = (e) => {
      const { name, value } = e.target;
      let tempForm = { ...userForm };
      let tempError = { ...userError };
      tempForm[name] = value;
  
      // ✅ Validation clearing
      if (name === "email" && EMAIL_CHECK(value)) delete tempError.email;
      if (name === "company_name" && NAME_CHECK_WITH_NUMBER(value)) delete tempError.company_name;
      if (name === "company_alias" && (value === "" || NAME_CHECK_WITH_NUMBER(value)))
        delete tempError.company_alias;
  
      setUserError(tempError);
      setUserForm(tempForm);
    };
  
    const handleDocumentChange = (e) => {
      setVerifierType(e);
      let tempError = { ...userError };
      delete tempError.category;
      setUserError(tempError);
    };
  
    return (
      <form onSubmit={handleAddUser}>
        <Loader isOpen={loading} />
  
        <div className={addIssuer.modalBody}>
    {showsuccessContent?
      <table width="100%" cellpadding="0" cellspacing="0" role="presentation" aria-hidden="true">
    <tr>
      <td align="center" style={{padding:"15px 7px"}}>
        <table className="container" width="600" cellpadding="0" cellspacing="0" role="presentation" style={{ background:"#ffffff", overflow:"hidden"}}>
          <tr>
            <td className="hero" style={{padding:"15px 0px"}}>
              {/* <h1 style="margin:0 0 12px 0; font-size:20px; color:#111111;">Hi {{CLIENT_NAME}},</h1> */}
              <p style={{margin:"0 0 18px 0", lineHeight:"1.5", color:"#444444"}}>
                Thanks for signing up. To finish creating your account, follow the steps.
              </p>
              <p style={{margin:"0 0 18px 0",lineHeight:"1.45", color:"#666666", fontSize:"13px"}}>
                <strong>Note:</strong> This link will expire in <strong>24 hours</strong> for security reasons.
              </p>
              <div style={{background:"#f7f9fc", border:"1px solid #eef3ff", padding:"16px", borderRadius:"6px"}}>
                <strong style={{display:"block", marginBottom:"8px", color:"#0b6cff",fontSize:"13px"}}>Onboarding Steps:</strong>
                <ol style={{margin:"0", paddingLeft:"18px", color:"#444444", lineHeight:"2.5", fontSize:"13px"}}>
                  <li>Click the <em>Registration</em> link sent to your email.</li>
                  <li>Fill out the form and set a strong password.</li>
                  <li>Verify your email using the OTP sent to you.</li>
                  <li>You’re all set—log in to your account.</li>
                </ol>
              </div>
            </td>
          </tr>
          </table>
          </td>
          </tr>
          </table>:    <>
          {/* Company Name */}
          <label className={addIssuer.required}>Company Name</label>
          <div className={addIssuer.emailInput}>
            <input
              name="company_name"
              className={addIssuer.input}
              placeholder="Company Name"
              value={userForm.company_name}
              onChange={handleChange}
            />
            {userError?.company_name && (
              <p style={{ color: "red" }}>Please Enter a Valid Company Name!</p>
            )}
          </div>
  
          {/* Alias */}
          <label>Company Alias</label>
          <div className={addIssuer.emailInput}>
            <input
              name="company_alias"
              className={addIssuer.input}
              placeholder="Company Alias"
              value={userForm.company_alias}
              onChange={handleChange}
            />
            {userError?.company_alias && (
              <p style={{ color: "red" }}>Please Enter a Valid Company Alias!</p>
            )}
          </div>
  
          {/* Email */}
          <label className={addIssuer.required}>Verifier Email</label>
          <div className={addIssuer.emailInput}>
            <input
              name="email"
              className={addIssuer.input}
              placeholder="name@example.com"
              value={userForm.email}
              onChange={handleChange}
            />
            {userError?.email && (
              <p style={{ color: "red" }}>Please Enter a Valid Email!</p>
            )}
          </div>
  
          {/* Verifier Type Dropdown (optional) */}
          {/* 
          <label className={addIssuer.required}>Verifier Type</label>
          <CustomDropDown
            list={["General", "Visitor", "Employment"]}
            selectedOption={verifierType}
            onSelect={handleDocumentChange}
          />
          {userError?.category && (
            <p style={{ color: "red" }}>Please choose a Verifier Type!</p>
          )}
          */}
  
          {/* Buttons */}
          <div className={addIssuer.popBtn} style={{ display: "flex", justifyContent: "flex-end", gap: "1rem" }}>
            <button onClick={() => setSignUpPopup(false)} type="button" className="secondaryBtn">
              {BUTTONS.CANCEL}
            </button>
            <button type="submit" disabled={loading} className="Modalbutton">
              {loading ? BUTTONS.ADDING : "Add User"}
            </button>
          </div>

          </>}
        </div>
      </form>
    );
  }

  const getConfig=()=>{
    API.get(GET_CONFIG_DETAILS)
    .then(res=>{
      if(res.data.status==200){
        dispatch(setConfig(res.data.data))
      }
    })
    .catch(err=>{
      console.log(err);
      
    })
  }
  const formHandler = (event) => {
    event.preventDefault();
    const hashValue = window.location.hash;

  if (hashValue) {
    localStorage.setItem("doc_token", hashValue)
  }
    if(email=="" || password==""){
      cogoToast.info("Please enter details to login")
    }
    else{
      let formData = { identifier: email, password }
      setLoading(true)
      API.post(USER_LOGIN, { ...formData })
        .then(res => {
          let data = res.data
          setLoading(false)
          if (data.success === true) {
            getConfig()
            const userData = { ...res.data.data, email };
            // localStorage.setItem("loginAttempts", MAX_ATTEMPTS)
            if (userData.user_type === "Super Admin") {
              dispatch(login(userData));
              navigate("/dashboard");
            } 
            else if(userData.user_type === "internal_user"){

              
              dispatch(login(userData))
              navigate("/users")
            }
            else if(userData.is_first_login && userData.mfa_enabled){

              navigate("/app/termandPolicy")
              dispatch(login(userData));
            }
            else if (userData.mfa_enabled) {
              dispatch(login(userData));
              navigate("/app/mfa");
            } 
            // else if (userData.is_first_login){
            //   navigate("/app/termandPolicy")
            //   dispatch(login(userData));
            // }
            else {
              userData.user_name = email;
              dispatch(updateUser(userData));
              navigate("/dashboard");
            }
          }
          // else if(res.data.status==400){
          //   let attemptsLeft = parseInt(localStorage.getItem("loginAttempts"));
          //   attemptsLeft--;
          //   localStorage.setItem("loginAttempts", attemptsLeft)
          //   if (attemptsLeft > 0) {
          //     cogoToast.error(`Incorrect password. Attempts left: ${attemptsLeft}`)
          //   }
          //   else {
          //     cogoToast.error("Too many failed attempts. Please try again later after some time.");
          //     localStorage.removeItem("loginAttempts")
          //   }
          // }
          else {
          cogoToast.error(data.message.slice(10))
          }
        }
      )
      .catch(err=>{
        cogoToast.error(err.message)
      }
      ).finally(()=>{
        setLoading(false)
      })
    }
  }


  const handleforgotPassword=()=>{
    navigate('/app/forgotPassword')
  }
  return (
    <>
    <form className={styles.card} onSubmit={formHandler}>
      <Loader isOpen ={loading} />
      <div className={styles.headingHelperText}>
        <h3 className={styles.heading}>Welcome back</h3>
      </div>
      <div className={rowStyle.row} style={{ flexDirection: "column" }}>
        <div className={rowStyle.inputField} style={{
          flex: "unset",
          minWidth: "unset",
          alignSelf: "stretch",
        }}>
          <div className={rowStyle.label} style={{ display: "inline-block" }}>
            Email
          </div>
          <div className={rowStyle.PassField}>
          <input className={rowStyle.input} placeholder="name@example.com" onChange={(e) => setemail(e.target.value)} value={email} />
          </div>
        </div>
      </div>

      <div className={rowStyle.row} style={{ flexDirection: "column" }}>
        <div className={rowStyle.inputField} style={{
          flex: "unset",
          minWidth: "unset",
          alignSelf: "stretch",
        }}>
          <div className={rowStyle.label} style={{ display: "inline-block" }}>
            Password
          </div>
          <div className={rowStyle.PassField}>
          <input type={passVisible?"text":"password"} className={rowStyle.input} placeholder="" onChange={(e) => setPassword(e.target.value)} value={password} autoComplete="on"/>
          {password &&
            <span onClick={()=>setPassVisible(!passVisible)}><Icon icon={passVisible?basic_eye:basic_eye_closed} size={20}/></span>
          }
          </div>
        </div>
      </div>
      <div className={styles.rememberMeLost}>
        {/* <div className={styles.termsAndCondition}>
          <input type="checkbox" className={styles.checkbox} onClick={() => setRememberMe(!rememberMe)} />
          <div className={styles.labelHelperText}>
            <div className={styles.writeLabelText} >Remember me</div>
          </div>
        </div> */}
        
        <div className={styles.forgotPassword} onClick={()=>{
          if (!disableLogin) {
              handleforgotPassword();
          
            }}} 
      style={{color:disableLogin?"lightgray":"#3f83f8"}}>Forgot Password ?</div>
      </div>
      <div className={styles.buttonHelperText}>
        <button className={`${disableLogin?"DisableprimaryBtn":"btn btn-primary"}`} style={{width:"100%"}} disabled={disableLogin}>
          <div className={styles.copyrightText}>Login</div>
        </button>
      </div>

      
      {/* <span style={{textAlign:"center",color:"#1c64f2", marginTop:'28px'}}>Note:If you’re an existing WorkAtTest user, reset your password using your WorkAtTest registered email. Your WorkAttest password won’t work here — please reset it before logging in.</span> */}
      <div
      className={styles.forgotPassword}
          style={{
            backgroundColor: "#fee2e2",
            color: "#b91c1c",
            padding: "0.75rem 1rem",
            borderRadius: "8px",
            margin: "15px 0px",
            fontSize:"16px",
            fontWeight: "500",
            textAlign: "center",
            width:"97%"
          }}
        >
          <span className={styles.cursor} onClick={()=>navigate("/app/Onboarding")}>Register as a New Verifier – Click Here</span>
          </div>
      <div className={styles.helperText}>
        <Link to="" className={styles.dontHaveAn}>Don’t have an account yet?</Link>
        <span className={styles.signUp}>Sign up</span>
      </div>
    </form>
    <Modal title="User Registration" isOpen={signUp} onClose={(e)=>setSignUpPopup(false)} blockOutsideClick={true} children={<AddSingleUsers blockOutsideClick={false} />} />
    </>
  );
};

export default LoginForm;
